if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      //if on cart page
      this.cartPage = document.querySelector('.main-cart cart-items');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('button--loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      let sectionsToFetch = [];

      if (this.cartNotification) {
        sectionsToFetch = [
          ...this.cartNotification.getSectionsToRender().map((section) => section.id),
        ];
      }

      if (this.cartDrawer) {
        sectionsToFetch = [
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
          ...(this.cartNotification
            ? this.cartNotification.getSectionsToRender().map((section) => section.id)
            : []),
        ];
      }

      if (this.cartPage) {
        sectionsToFetch = [
          ...this.cartPage.getSectionsToRender().map((section) => section.section),
          ...(this.cartNotification
            ? this.cartNotification.getSectionsToRender().map((section) => section.id)
            : []),
        ];
      }

      const formData = new FormData(this.form);

      if (Object.fromEntries(formData).id === '') {
        submitButton.classList.remove('button--loading');
        submitButton.removeAttribute('disabled');
        this.handleNoVariantSelected();
        return;
      }

      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          if (this.cartDrawer) {
            this.cartDrawer.renderContents(parsedState);
          }

          if (this.cartPage) {
            this.cartPage.updateSections(parsedState);
            this.cartPage.scrollTop = 0;
          } else {
            switch (submitButton.dataset.addToCartBehavior) {
              case 'open_cart_drawer':
                // Set timeout to force animation. Because content is just updated with renderContents
                setTimeout(() => {
                  this.cartDrawer.open();
                });
                break;
              case 'show_cart_notification':
              default:
                this.cartNotification.setActiveElement(document.activeElement);
                this.cartNotification.renderContents(parsedState);
                this.mainCartItems?.renderContents(parsedState);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const variants = document.querySelector('.variants-sizeguide-wrapper');
          submitButton.classList.remove('button--loading');
          submitButton.removeAttribute('disabled');
          this.clearErrors();
        });
    }

    /**
     * Handle when no variant is selected
     */
    handleNoVariantSelected() {
      const variants = document.querySelector('.variants-sizeguide-wrapper'),
        variantsTop = variants.offsetTop;

      this.clearErrors();
      window.scrollTo({ top: variantsTop - 100, behavior: 'smooth' });
      variants.classList.add('border', 'border-danger', 'rounded', 'mb-3');
      variants.appendChild(this.createVariantError());
    }

    /**
     * Create the variant error message
     * @returns {HTMLDivElement}
     */
    createVariantError() {
      const error = document.createElement('div');
      error.classList.add('text-danger', 'text-sm', 'mt-2', 'no-variant-error');
      error.textContent = 'Please select a variant';
      return error;
    }

    /**
     * Clear variant error message  and border  on variants
     * @returns {void}
     */
    clearErrors() {
      const variants = document.querySelector('.variants-sizeguide-wrapper'),
        error = document.querySelector('.no-variant-error');

      if (error) {
        error.remove();
        variants.classList.remove('border', 'border-danger', 'rounded', 'mb-3');
      }
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);

  document.addEventListener('cart:build', function (cart) {
    var thisCartDrawer = document.querySelector('cart-drawer');
    if(thisCartDrawer) {
      setTimeout(() => {
        thisCartDrawer.open();
      }, 1500);
    }
  }, false);
}
